import { Stack } from "@mui/material";
import { styled } from "@mui/material/styles";
import { HubCardStack } from "../../components";

export const StyledDisplayStack = styled(Stack)({
  gap: "15px",
  width: "100%",
  height: "100%",
  overflow: "hidden",
});

export const StyledContainer = styled(Stack)({
  height: "100%",
  width: "100%",
  overflow: "auto",
  position: "relative",
  "::-webkit-scrollbar": {
    display: "none",
  },
});

export const StyledCardStack = styled(HubCardStack)({
  width: "auto",
  overflow: "visible",
  minHeight: "fit-content",
  height: "100%",
  margin: "50px auto",
  minWidth: "500px",
  maxWidth: "1000px",
  width: "100%",
  padding: 0,
});
